import type { TaskDetailScreenModel } from './TaskDetailScreenModelScreen';

export class TaskDetailScreenController {
  constructor(private readonly model: TaskDetailScreenModel) {}

  handleGoBack = () => {
    this.model.onGoBack?.();
  };

  handleClaim = () => {
    if (!this.model.content.actionEnabled || this.model.actionInFlight) {
      return;
    }
    this.model.onClaim?.();
  };
}
